import '../../utils/index.mjs';
import Row from './src/row.mjs';
export { rowProps } from './src/row.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElRow = withInstall(Row);

export { ElRow, ElRow as default };
//# sourceMappingURL=index.mjs.map
